import { render, staticRenderFns } from "./PedidosPendentes.vue?vue&type=template&id=599fbe13"
import script from "./PedidosPendentes.vue?vue&type=script&lang=js"
export * from "./PedidosPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports